import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createMatInwardEntry = createAsyncThunk('createMatInwardEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertMaterialInward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateMatInwardEntry = createAsyncThunk('updateMatInwardEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateMaterialInward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMatInwardData = createAsyncThunk('fetchMatInwardData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialInwardList`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleMatInward = createAsyncThunk('fetchSingleMatInward', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialInwardList&matInwId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});





export const deleteSingleMatInward = createAsyncThunk('deleteSingleMatInward', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteMaterialInward&matInwId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMatStkValue = createAsyncThunk('fetchMatStkValue', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialInwardList&matId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const matInwardSlice = createSlice({
    name: 'MatInwardData',
    initialState: {
        isLoading: false,
        matInward: null,
        deleteMatInward: null,
        singleMatInward: null,
        stkValue: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMatInwardData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMatInwardData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.matInward = action.payload;
        });
        builder.addCase(fetchMatInwardData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleMatInward.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleMatInward.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteMatInward = action.payload;
        });
        builder.addCase(deleteSingleMatInward.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleMatInward.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleMatInward.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleMatInward = action.payload;
        });
        builder.addCase(fetchSingleMatInward.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchMatStkValue.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMatStkValue.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stkValue = action.payload;
        });
        builder.addCase(fetchMatStkValue.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



    }
});

export default matInwardSlice.reducer;
